import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const WelcomeSection = () => {
  const { t } = useLanguage();
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <section className="py-16 md:py-24 bg-[#1a1f2e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{t('welcomeMessage')}</h2>
          <p className="text-gray-400 text-lg">
            {t('welcomeDesc')}
          </p>
        </div>

        {/* Video Thumbnail */}
        <div className="max-w-4xl mx-auto">
          <div 
            className="relative rounded-2xl overflow-hidden cursor-pointer group"
            onClick={() => setIsVideoOpen(true)}
          >
            {/* Video Preview Image */}
            <div className="relative aspect-video bg-gradient-to-br from-[#2a3142] to-[#1a1f2e] flex items-center justify-center">
              <div className="absolute inset-0 flex items-center">
                {/* Left instructor */}
                <div className="w-1/2 h-full relative overflow-hidden">
                  <img
                    src="https://horizons-cdn.hostinger.com/18a1a0ab-885d-4c22-add1-e6337891edf7/a13f51a2c0be45427a7d8ab30aeff9bd.jpg"
                    alt="Dr. Nawwaf Alshibli"
                    className="w-full h-full object-cover"
                    style={{ clipPath: 'polygon(0 0, 90% 0, 70% 100%, 0 100%)' }}
                  />
                </div>
                {/* Right instructor */}
                <div className="w-1/2 h-full relative overflow-hidden">
                  <img
                    src="https://horizons-cdn.hostinger.com/18a1a0ab-885d-4c22-add1-e6337891edf7/10c74f18fe2c3508d765dbb95aa54bbc.jpg"
                    alt="Inanna Nolan"
                    className="w-full h-full object-cover"
                    style={{ clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 10% 100%)' }}
                  />
                </div>
                {/* Golden decorative elements */}
                <div className="absolute inset-0 border-[6px] border-[#d4a33a]/30 rounded-lg pointer-events-none" />
              </div>
              
              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center z-10">
                <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-xl">
                  <Play className="w-8 h-8 text-white fill-white ml-1" />
                </div>
              </div>
              
              {/* Decorative corners */}
              <div className="absolute top-4 left-4 w-16 h-16 border-l-2 border-t-2 border-[#d4a33a]/50" />
              <div className="absolute top-4 right-4 w-16 h-16 border-r-2 border-t-2 border-[#d4a33a]/50" />
              <div className="absolute bottom-4 left-4 w-16 h-16 border-l-2 border-b-2 border-[#d4a33a]/50" />
              <div className="absolute bottom-4 right-4 w-16 h-16 border-r-2 border-b-2 border-[#d4a33a]/50" />
            </div>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {isVideoOpen && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
          <button
            onClick={() => setIsVideoOpen(false)}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
          >
            <X className="w-8 h-8" />
          </button>
          <div className="w-full max-w-4xl aspect-video">
            <iframe
              className="w-full h-full rounded-lg"
              src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
              title="Welcome Message"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default WelcomeSection;
